<script>
import Endpoints from '../../../../components/common/Endpoints';
import Common from '../../../../components/common/Common';
import Request from '../../../../components/common/Request';

export default {
    init: (payload) => {
        const el = document.body;
        el.removeAttribute("class");
        $('.modal').modal('hide');
        
        payload.domain = Endpoints.domain;//nao remover, usado para apresentar a foto
        payload.filter();

    },
    methods:{
        filter: function(){
            let state = this;
            setTimeout(async function(){
              let trucker = (await Request.do(state, 'POST', Request.getDefaultHeader(state), {} ,`${Endpoints.reports.trucker.withoutVehicle}`));
                if (trucker.status==200){
                    console.log(trucker.data.results);
                    state.items = trucker.data.results;
                }
        }, 200);
        },
        fetchData(){
            // console.log(this.items.companyUser.company);
            this.json_data = this.items;
            return this.json_data;
        },
        camelize: Common.camelize,
        toUpperCase: Common.toUpperCase,
    }
}
</script>